import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import FormCheckbox from '../../_shared/forms/FormCheckbox';
import moment from 'moment';
import Select from 'react-select';
import FormMultiSelect, { SearchableSelect } from '../../_shared/forms/FormMultiSelect';
import JobExtras from '../JobExtras';
import SubmitButton from '../../_shared/SubmitButton';
import DtnService from '../../../services/DtnService';
import FormInputText from '../../_shared/forms/FormInputText';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import JobDetails from './paritals/JobDetails';
import DtnPhotos from './paritals/DtnPhotos';
import DriverSignature from './paritals/DriverSignature';
import PricingDetails from './paritals/PricingDetails';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import StatusButtons from './paritals/StatusButtons';
import EditVolumeJobs from './EditVolumeJobs';
import CustomerDetails from './paritals/CustomerDetails';
import OperativeDetails from './paritals/OperativeDetails';
import CreateFollowOnButton from '../../_shared/CreateFollowOnButton';

class EditGardening extends Component {
    constructor(props) {
        super(props);
        let { job, dtn, type } = this.props;

        let collectionDate = dtn.collection_date ? new Date(dtn.collection_date) : '';

        let completionTime = dtn.completion_time ? new Date(dtn.completion_time) : '';

        let tipOffOptions = [...this.props.tipOffOptions];
        let tipOff = tipOffOptions.find((tipOff) => {
            return tipOff.value === this.props.job.tip_off_id;
        });

        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collectionDate || '',
            completion_time: completionTime || '',
            job_notes: dtn.job_notes || '',
            waste_cleared: type.waste_cleared || 0,
            provider_waste_cleared: type.provider_waste_cleared || 0,
            other_work: type.other_work || '',
            job_complete: type.job_complete || '',
            job_complete_options: [
                { label: 'Complete', value: 'complete' },
                { label: 'Revisit', value: 'revisit' },
            ],
            extrasOptions: this.props.jobExtras,
            gardeningExtrasOptions: this.props.gardeningExtras,
            selectedExtras: job.job_extras || '',
            selectedGardeningExtras: job.gardening_extras || '',
            jobTypePrice: 0,
            providerJobTypePrice: 0,
            wasteRemovedPrice: 0,
            providerWasteRemovedPrice: 0,
            totalPrice: 0,
            providerTotalPrice: 0,
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            customer_signature: '',
            rejected_files: {},
            errors: {},
            job_extras: {},
            gardening_extras: {},
            loading: false,
            tipOff: typeof tipOff !== 'undefined' ? tipOff : [],
            provider_quantity: job.provider_quantity || 0,
            quantity: job.quantity || 0,
            admin_notes: job.admin_notes || '',
            purchase_order_number: job.purchase_order_number || '',
            sla: job.sla || '',
            price_quoted: job.price_quoted === 1 ? 'yes' : 'no',
            custom_price: job.custom_price || 0,
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : 0,
            disable_status_buttons: false,
            provider_price_quoted: job.provider_price_quoted === 1 ? 'yes' : 'no',
            provider_custom_price: job.provider_custom_price || '',
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
            route_started: '',
            route_arrived: '',
            first_operative: {},
            second_operative: {},
            job_completed: '',
            manager_review: job.manager_review ? 'yes' : 'no',
            manager_review_reason: job.manager_review_reason || '',
        };

        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        let providerJobTypePrice = this.setProviderJobTypePrice();

        this.calculateTotalPrice(jobTypePrice, providerJobTypePrice);

        // if(!this.props.job.waste_tipping_id && this.props.job.status !== 'completed') {
        //     this.jobNotTippedModal();
        // }
    }

    jobNotTippedModal = () => {
        window.swal.fire({
            title: `Waste not tipped`,
            text: ``,
            type: 'info',
            confirmButtonText: `Ok`,
        });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot ? jobType.pivot.price : jobType.default_price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    setProviderJobTypePrice = () => {
        let providerJobType = this.props.serviceProvider.job_types.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });
        let providerJobTypePrice;

        if (typeof providerJobType !== 'undefined') {
            providerJobTypePrice = providerJobType.pivot ? providerJobType.pivot.price : providerJobType.default_price;
        } else {
            providerJobType = this.props.jobTypes.find((jobType) => {
                return jobType.id === this.props.job.job_type_id;
            });
            providerJobTypePrice = providerJobType.provider_default_price || 0;
        }

        this.setState({
            providerJobTypePrice: providerJobTypePrice,
        });

        return providerJobTypePrice;
    };

    calculateTotalPrice = (jobTypePrice, providerJobTypePrice) => {
        let totalPrice = jobTypePrice * this.state.quantity;
        let providerTotalPrice = providerJobTypePrice * this.state.provider_quantity;
        let wasteRemovedPrice = this.state.waste_cleared ? this.state.waste_cleared * 3510 : 0;
        let providerWasteRemovedPrice = this.state.provider_waste_cleared * 3510;

        totalPrice += wasteRemovedPrice;
        providerTotalPrice += providerWasteRemovedPrice;

        if (this.state.selectedExtras) {
            this.state.selectedExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                providerTotalPrice += extra.providerPrice * (extra.provider_quantity || 0);
            });
        }

        if (this.state.selectedGardeningExtras) {
            this.state.selectedGardeningExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                providerTotalPrice += extra.providerPrice * (extra.provider_quantity || 0);
            });
        }

        this.setState({
            totalPrice: totalPrice,
            providerTotalPrice: providerTotalPrice,
            wasteRemovedPrice: wasteRemovedPrice,
            providerWasteRemovedPrice: providerWasteRemovedPrice,
        });
    };

    handleChange = (e) => {
        let { name, value, type } = e.target;
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (
            type === 'checkbox' &&
            (name === 'price_quoted' || name === 'provider_price_quoted' || name === 'manager_review')
        ) {
            value = this.state[name] === 'yes' ? 'no' : 'yes';
        }

        this.setState(
            {
                [name]: value,
                errors: errorsObject,
            },
            () => {
                if (name === 'provider_quantity' || name === 'quantity') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    handleSelectChange = (data) => {
        this.setState({
            job_complete: data.value,
        });
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];
        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];
            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }
            if (
                !extras[extras.length - 1].hasOwnProperty('provider_quantity') ||
                extras[extras.length - 1].provider_quantity === ''
            ) {
                extras[extras.length - 1].provider_quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleTotalWasteChange = (e) => {
        let { name, value, type } = e.target;
        let errorObject = { ...this.state.errors };
        delete errorObject[name];

        this.setState(
            {
                [name]: value,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerTotalPrice);
            }
        );
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][e.target.name] = e.target.value;

        if (e.target.name === 'quantity') {
            extras[extraIndex]['provider_quantity'] = e.target.value;
        }

        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerTotalPrice);
            }
        );
    };

    handleCustomPriceChange = (e) => {
        let { name, value } = e.target;

        const numericValue = Number(value); // key fix

        let custom_price, custom_price_with_vat;

        if (name === 'custom_price') {
            custom_price = numericValue;
            custom_price_with_vat = +(numericValue * 1.2).toFixed(2);
        } else {
            custom_price_with_vat = numericValue;
            custom_price = +(numericValue / 1.2).toFixed(2);
        }

        this.setState({
            custom_price,
            custom_price_with_vat,
        });
    };

    handleProviderCustomPriceChange = (e) => {
        const { name, value } = e.target;
        const numericValue = parseFloat(value) || 0;
        if (name === 'provider_custom_price') {
            this.setState({
                provider_custom_price: numericValue,
                provider_custom_price_with_vat: +(numericValue * 1.2).toFixed(2),
            });
        } else {
            this.setState({
                provider_custom_price_with_vat: numericValue,
                provider_custom_price: +(numericValue / 1.2).toFixed(2),
            });
        }
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    handleSearchableSelectChange = (e, name) => {
        this.setState({
            [name]: e,
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'completion_time',
            'job_notes',
            'waste_cleared',
            'provider_waste_cleared',
            'job_complete',
            'other_work',
            'provider_quantity',
            'quantity',
            'admin_notes',
            'sla',
            'purchase_order_number',
            'custom_price',
            'price_quoted',
            'provider_price_quoted',
            'provider_custom_price',
        ];

        // if (!this.props.dtn.id) {
        //     mappable.push('route_started');
        //     mappable.push('route_arrived');
        //     mappable.push('job_completed');
        // }
        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        this.state.customer_signature ? formData.append('customer_signature', this.state.customer_signature[0]) : '';
        formData.append('job_extras', JSON.stringify(this.state.selectedExtras));
        formData.append('gardening_extras', JSON.stringify(this.state.selectedGardeningExtras));
        formData.append('tip_off_id', this.state.tipOff.value || '');
        if (!this.props.dtn.id) {
            formData.append('first_operative', this.state.first_operative.value || '');
            formData.append('second_operative', this.state.second_operative.value || '');
        }
        mappable.forEach((input) => {
            if (
                input === 'collection_date' ||
                input === 'completion_time' ||
                input === 'route_started' ||
                input === 'route_arrived' ||
                input === 'job_completed'
            ) {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });
        formData.append('manager_review', this.state.manager_review === 'yes' ? 1 : 0);
        formData.append('manager_review_reason', this.state.manager_review_reason);

        return formData;
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({ errors: {} });

        if (this.props.dtn.id) {
            this.onSubmitValidateUpdate(e);
        } else {
            this.onSubmitValidateStore(e);
        }
    };

    saveDtn = async (shouldReload = true) => {
        try {
            if (this.props.dtn.id) {
                await this.onSubmitValidateUpdate(shouldReload);
            } else {
                await this.onSubmitValidateStore(shouldReload);
            }
            return true;
        } catch (err) {
            return false;
        }
    };
    onSubmitValidateStore = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        try {
            const res = await this.dtnService.storeDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully saved');
            if (shouldReload) location = this.props.editRoute;
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    onSubmitValidateUpdate = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();
        formData.append('_method', 'PATCH');

        try {
            const res = await this.dtnService.updateDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully edited');
            if (shouldReload) window.location.reload();
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'address',
            'postcode',
            'collection_date',
            'completion_time',
            'waste_cleared',
            'provider_waste_cleared',
            'job_complete',
        ];

        if (this.state.price_quoted === 'yes') {
            fields.push('custom_price');
        }

        if (this.state.provider_price_quoted === 'yes') {
            fields.push('provider_custom_price');
        }

        // if (!this.props.dtn.id) {
        //     fields.push('route_started');
        //     fields.push('route_arrived');
        //     fields.push('first_operative');
        //     fields.push('job_completed');
        // }

        fields.map((field) => {
            if (!this.state[field] || this.state[field] === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    };

    disableStatusButtons = () => {
        this.setState({
            disable_status_buttons: true,
        });
    };

    render() {
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} encType="multipart/form-Fata" className="transform-text">
                    <CustomerDetails
                        customer={this.props.job.customer.name}
                        customer_contact={this.props.job.contact.first_name + ' ' + this.props.job.contact.last_name}
                        job_source={this.props.job_source ? this.props.job_source.job_source : ''}
                        purchase_order_number={this.state.purchase_order_number}
                        sla={this.state.sla}
                        department={this.props.job.contact ? this.props.job.contact.department.name : ''}
                        handleChange={this.handleChange}
                    />

                    <JobDetails
                        address={this.state.address}
                        postcode={this.state.postcode}
                        collection_date={this.state.collection_date}
                        completion_time={this.state.completion_time}
                        job_notes={this.state.job_notes}
                        errors={this.state.errors}
                        handleChange={this.handleChange}
                        handleDateChange={this.handleDateChange}
                        tipOff={this.state.tipOff}
                        tipOffOptions={this.props.tipOffOptions}
                        handleSearchableSelectChange={this.handleSearchableSelectChange}
                        provider_quantity={this.state.provider_quantity}
                        quantity={this.state.quantity}
                        manager_review={this.state.manager_review}
                        manager_review_reason={this.state.manager_review_reason}
                        manager_review_flag_reason={this.props.job.manager_review_flag_reason}
                    />

                    {!this.props.dtn.id ? (
                        <OperativeDetails
                            first_operative={this.state.first_operative}
                            second_operative={this.state.second_operative}
                            second_member_id={this.state.second_member_id}
                            route_started={this.state.route_started}
                            route_arrived={this.state.route_arrived}
                            job_completed={this.state.job_completed}
                            errors={this.state.errors}
                            operatives={this.props.operatives}
                            handleDateChange={this.handleDateChange}
                            handleChange={this.handleChange}
                            handleSearchableSelectChange={this.handleSearchableSelectChange}
                        />
                    ) : (
                        ''
                    )}

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job notes</h6>
                        </div>
                    </div>
                    {this.props.previousFollowOnDescription ? (
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Previous job notes</label>
                                <textarea
                                    name="previous_job_notes"
                                    id="previous_job_notes"
                                    className="form-control"
                                    value={this.props.previousFollowOnDescription}
                                    rows={5}
                                    disabled
                                >
                                    {this.props.previousFollowOnDescription}
                                </textarea>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Admin notes</label>
                            <textarea
                                name="admin_notes"
                                id="admin_notes"
                                rows={5}
                                value={this.state.admin_notes}
                                onChange={this.handleChange}
                                placeholder="Admin note"
                                className="form-control"
                            >
                                {this.state.admin_notes}
                            </textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Job notes</label>
                            <textarea
                                className="form-control"
                                name="job_notes"
                                id="job_notes"
                                value={this.state.job_notes}
                                onChange={this.handleChange}
                                placeholder="Job notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Other details</h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                name="waste_cleared"
                                label="How much waste needs clearing form the gardens(CY)?"
                                value={this.state.waste_cleared}
                                handleChange={this.handleTotalWasteChange}
                                classes={this.state.errors.waste_cleared ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_cleared}
                                step={1}
                                min={0}
                            />
                            <p>Total waste removed price: &pound;{this.state.wasteRemovedPrice / 100}</p>
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                name="provider_waste_cleared"
                                label="How much waste provider cleared from the garden (CY)?"
                                value={this.state.provider_waste_cleared}
                                handleChange={this.handleTotalWasteChange}
                                classes={
                                    this.state.errors.provider_waste_cleared
                                        ? 'form-control is-invalid'
                                        : 'form-control'
                                }
                                error={this.state.errors.provider_waste_cleared}
                                step={1}
                                min={0}
                            />
                            <p>
                                Provider total waste removed price: &pound;{this.state.providerWasteRemovedPrice / 100};
                            </p>
                        </div>
                        <div className="form-group col-md-4">
                            <label>Job complete?</label>
                            <Select
                                classes={this.state.errors.job_complete ? 'is-invalid' : ''}
                                name="job_complete"
                                options={this.state.job_complete_options}
                                value={this.state.job_complete_options.find(
                                    (option) => option.value === this.state.job_complete
                                )}
                                onChange={this.handleSelectChange}
                                error={this.state.errors.job_complete}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label>Any other work required?</label>
                            <textarea
                                className="form-control"
                                name="other_work"
                                id="other_work"
                                value={this.state.other_work}
                                onChange={this.handleChange}
                                placeholder="Other work"
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste that needs clearing</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Job Extras"
                                options={this.state.extrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedExtras')
                                }
                                classes={'form-control'}
                                prefixes={this.state.selectedExtras}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Gardening Extras"
                                options={this.state.gardeningExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedGardeningExtras')
                                }
                                onExtraQtyChange={this.handleExtraQtyChange}
                                classes="form-control"
                                prefixes={this.state.selectedGardeningExtras}
                            />
                        </div>
                    </div>
                    <JobExtras
                        extras={this.state.selectedExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedExtras'}
                        extrasPrices={this.props.jobExtras}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'job_extras'}
                        dtn={true}
                    />
                    <JobExtras
                        extras={this.state.selectedGardeningExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedGardeningExtras'}
                        extrasPrices={this.props.gardeningExtras}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'gardening_extras'}
                        dtn={true}
                    />

                    <PricingDetails
                        totalPrice={this.state.totalPrice}
                        timeSpentWorking={this.props.timeSpentWorking}
                        laborCost={this.props.laborCost}
                        providerTotalPrice={this.state.providerTotalPrice}
                        price_quoted={this.state.price_quoted}
                        custom_price={this.state.custom_price}
                        custom_price_with_vat={this.state.custom_price_with_vat}
                        provider_price_quoted={this.state.provider_price_quoted}
                        provider_custom_price={this.state.provider_custom_price}
                        provider_custom_price_with_vat={this.state.provider_custom_price_with_vat}
                        handleProviderCustomPriceChange={this.handleProviderCustomPriceChange}
                        handleChange={this.handleChange}
                        handleCustomPriceChange={this.handleCustomPriceChange}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media ? this.props.media.images_before : null}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media ? this.props.media.images_after : null}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media ? this.props.media.van_images_before : null}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media ? this.props.media.van_images_after : null}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DriverSignature imagePath={this.props.signaturePath} driver={this.props.driver} />

                    <DtnPhotos
                        title="Customer signature"
                        name="customer_signature"
                        acceptedFiles={this.state.customer_signature}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media ? this.props.media.customer_signature : null}
                        multiple={false}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <SubmitButton
                        buttonText={this.props.dtn.id ? 'Edit WTN' : 'Create WTN'}
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 50 }}
                    />
                    <a
                        href={this.props.downloadUrl}
                        className="btn btn-cw-green"
                        style={{ width: 200, marginTop: 50, marginLeft: 15 }}
                    >
                        Download WTN
                    </a>

                    {this.props.job.status === 'done' ? (
                        <StatusButtons
                            job={this.props.job}
                            jobId={this.props.job.id}
                            style={{ marginTop: 50 }}
                            disabled={this.state.disable_status_buttons}
                            disableStatusButtons={this.disableStatusButtons}
                            saveDtn={this.saveDtn}
                            user={this.props.currentUser}
                        />
                    ) : (
                        ''
                    )}

                    <CreateFollowOnButton
                        job={this.props.job}
                        nextFollowOnPageRoute={this.props.nextFollowOnPageRoute}
                    />  
                </form>

                <div className="row">
                    <div className="col-md-6 text-left">
                        {this.props.previousFollowOnRoute ? (
                            <a href={this.props.previousFollowOnRoute}>Previous follow-on job</a>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="col-md-6 text-right">
                        {this.props.nextFollowOnRoute ? (
                            <a href={this.props.nextFollowOnRoute}>Next follow-on job</a>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

if (document.getElementById('gardening-form')) {
    let element = document.getElementById('gardening-form');
    ReactDOM.render(
        <EditGardening
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            gardeningExtras={JSON.parse(element.dataset.gardening_extras)}
            jobTypes={JSON.parse(element.dataset.job_types)}
            timeSpentWorking={element.dataset.time_spent_working}
            laborCost={element.dataset.labor_cost}
            media={element.dataset.media ? JSON.parse(element.dataset.media) : null}
            signaturePath={element.dataset.signature_path}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            downloadUrl={element.dataset.download_url}
            serviceProvider={JSON.parse(element.dataset.service_provider)}
            driver={element.dataset.driver !== null ? JSON.parse(element.dataset.driver) : null}
            completeAndFollowOnRoute={element.dataset.status_and_follow_on_route}
            previousFollowOnDescription={element.dataset.previous_follow_on_description}
            previousFollowOnRoute={element.dataset.previous_follow_on_route}
            nextFollowOnRoute={element.dataset.next_follow_on_route}
            nextFollowOnPageRoute={element.dataset.next_follow_on_page_route}
            operatives={element.dataset.operatives ? JSON.parse(element.dataset.operatives) : []}
            editRoute={element.dataset.edit_route}
            currentUser={JSON.parse(element.dataset.currentUser)}
        />,
        element
    );
}
